module.exports = __webpack_public_path__ + "img/windows.002f953d.svg";